import React, { useEffect } from 'react'
import CustomTime from 'designer/component/element/Time'
import objectPath from 'object-path'
import moment from 'moment'
import { copyDataByCondition } from 'designer/component/action/Condition'
import { onUpdateCondition } from 'designer/component/action/condition/Action'
import { isEmpty } from 'designer/component/action/condition/State'
import { getStorage } from 'designer/component/action/Storage'
import PropWrapper from './PropWrapper'
import {
  updateFieldValue,
  updateMapResponse,
  updateOnChange,
  updateWidgetData,
} from './DataControl'

const Children = ({ dataProps }) => {
  const {
    props,
    designContext,
    fieldProps,
    fieldName,
    fieldKey,
    errors,
    setIsOnChange,
  } = dataProps
  const { jsonForm, setFormData, isResetData, elementAction } = designContext
  const { uischema } = props
  let { defaultType, label } = uischema
  const formData = jsonForm.formData || {}
  const { uiKey, uiName, value, defaultValue, renderWidget, mapResponse } =
    fieldProps
  let time = value

  const updateData = (time, isOnChange) => {
    let value = null
    if (time?.format) {
      value = moment(time.format).format('HH:mm:ss')
    } else {
      value = time.value
    }
    updateValue(value, isOnChange)
  }

  const updateValue = (value, isOnChange) => {
    updateFieldValue({ ...dataProps, value, isOnChange })
  }

  const copyData = (time) => {
    let value = null
    if (time?.format) {
      value = moment(time.format).format('HH:mm:ss')
    }
    let newFormData = copyDataByCondition(value, elementAction, uiKey, formData)
    setFormData(newFormData)
  }

  useEffect(() => {
    updateOnChange({ ...dataProps, value })
  }, [value])

  useEffect(() => {
    if (isEmpty(time) || isResetData) {
      let currentTime = defaultValue
      if (defaultType === 'current') {
        currentTime = moment().format('HH:mm:ss')
      }
      let storage = getStorage(jsonForm, uiName)
      let value
      if (isEmpty(storage)) {
        value = currentTime
      } else {
        value = storage
      }
      updateValue(value)
    }
  }, [defaultValue])

  useEffect(() => {
    updateMapResponse(dataProps)
  }, [mapResponse])

  useEffect(() => {
    updateWidgetData(dataProps)
  }, [renderWidget])

  return (
    <CustomTime
      fieldName={fieldName}
      fieldKey={fieldKey}
      label={label}
      uischema={uischema}
      time={time}
      updateData={updateData}
      copyData={copyData}
      errors={errors}
      setIsOnChange={setIsOnChange}
    />
  )
}

const TimeControl = (props) => {
  return (
    <PropWrapper {...props}>
      {({ dataProps }) => <Children dataProps={dataProps} />}
    </PropWrapper>
  )
}

export default TimeControl
